import styled from 'styled-components';
import { palette } from 'styled-theme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background-color: ${palette('background', 3)};
  width: 800px;
  max-width: 90%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  z-index: 10000;
`;

export const ModalBody = styled.div`
  padding: 10px 0;
`;
